import { Avatar } from "@mui/material";
import BaseCard from "../../../components/ui/BaseCard";
import dayjs from "dayjs";
import { getTimeZoneAbbreviation } from "../../../utils/getTimeZoneAbbreviation";
import { decimalHoursToHHMM } from "../../../utils/decimalHoursToHHMM";

const TotalTimeLog = ({ totalHours, timeLogs, timeZone, engineerName }) => {
  return (
    <div className="w-full border rounded mt-4 mb-3">
      <div className="border-bottom mb-4 flex items-center pb-1 ml-6 mt-3 mb-4 mr-6">
        <h6 className={"!text-primary"}>Work Summary</h6>
      </div>
      <div className="grid grid-cols-3 gap-x-10 gap-y-4 mt-4 sm:mt-8 mb-4 sm:mb-8">
        <div className="lg:col-span-1 col-span-3 flex items-center lg:justify-start justify-between py-1.5 px-4 sm:px-8">
          <Avatar />
          <p className="text-primary text-[18px] font-semibold ml-3">
            {decimalHoursToHHMM(totalHours)}
          </p>
        </div>

        <div className="lg:col-span-1 col-span-3  py-1.5  ">
          <p className="font-normal w-36 text-[#71A534]">Time In</p>
          <div className="flex items-center mt-2">
            <i class="fa-regular fa-clock bg-blue-800 text-white px-1 text-xl rounded"></i>
            <div className="ml-2">
              <p className="leading-none">
                {timeLogs?.[0]?.checkInTime
                  ? dayjs(timeLogs[0].checkInTime)
                    .tz(timeZone)
                    .format("MMM D, YYYY hh:mm A") 
                  : "N/A"}
              </p>
              <p className="leading-none mt-1">
                {timeZone} ({getTimeZoneAbbreviation(timeZone)})
              </p>
            </div>
          </div>
        </div>

        <div className="lg:col-span-1 col-span-3  py-1.5">
          <p className="font-normal w-36 text-[#FF0000]">Time Out</p>
          <div className="flex items-center mt-2">
            <i class="fa-regular fa-clock bg-blue-800 text-white px-1 text-xl rounded"></i>
            <div className="ml-2">
              <p className="leading-none">
                {timeLogs?.[timeLogs.length - 1]?.checkOutTime
                  ? dayjs(timeLogs[timeLogs.length - 1]?.checkOutTime)
                    .tz(timeZone)
                    .format("MMM D, YYYY hh:mm A")
                  : "N/A"}
              </p>
              <p className="leading-none mt-1">
                {timeZone} ({getTimeZoneAbbreviation(timeZone)})
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TotalTimeLog;
